import { render } from "./AppDropdownIngredients.vue?vue&type=template&id=4c80a61b&scoped=true"
import script from "./AppDropdownIngredients.vue?vue&type=script&lang=js"
export * from "./AppDropdownIngredients.vue?vue&type=script&lang=js"

import "./AppDropdownIngredients.vue?vue&type=style&index=0&id=4c80a61b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c80a61b"]])

export default __exports__